<template>
  <v-app>
    <!-- <v-toolbar -->
    <v-app-bar v-if="this.$route.path !== '/login'" app color="primary" dark>
      <div class="d-flex align-center logo" @click="onLogo">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="logo"
          @click.stop="onLogo"
          transition="scale-transition"
          width="40"
        />

        <div :class="{ title: true }">{{ this.$t('navigator.title') }}</div>
      </div>

      <v-spacer></v-spacer>

      <v-btn target="_blank" text @click="onNewAlbum">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="add_logo"
          transition="scale-transition"
          width="24"
          height="24"
        />
        <span class="mr-2">{{this.$t('navigator.add_album')}}</span>
      </v-btn>
      <!-- <v-btn target="_blank" text @click="onUploadSheet">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="upload_logo"
          transition="scale-transition"
          width="24"
          height="24"
        />
        <span class="mr-2">{{this.$t('navigator.upload_sheet')}}</span>
      </v-btn> -->
      <v-btn target="_blank" text @click="onHandbook">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="handbook_logo"
          transition="scale-transition"
          width="24"
          height="24"
        />
        <span class="mr-2">{{this.$t('navigator.handbook')}}</span>
      </v-btn>
      <v-spacer></v-spacer>

      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn
            height="26"
            color="white normal-text mr-4"
            depressed
            rounded
            class="textcolor--text"
            v-on="on"
          >{{ currentLang }}</v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in langList" :key="index" @click="changeLang(item)">
            <v-list-item-title class="normal-text">{{ item }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div class="mr-2 normal-text">{{ $store.getters.userInfo.display_name }}</div>
      <v-btn target="_blank" text @click="logout">
        <span class="mr-2">{{this.$t('login.logout')}}</span>
      </v-btn>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    logo: require("./assets/logo.svg"),
    name_logo: require("./assets/logo_name.svg"),
    add_logo: require("./assets/img/navigator_bar_add.svg"),
    upload_logo: require("./assets/img/navigator_bar_upload.svg"),
    handbook_logo: require("./assets/img/navigator_bar_handbook.svg"),
    langList: ["中文", "English"],
    username: ""
  }),
  computed: {
    currentLang: function() {
      if (this.$i18n.locale == "zh") return "中文";
      // if (this.$i18n.locale == 'en')
      return "English";
    },
  },
  created() {

      console.log('app created');
  },
  methods: {
    changeLang: function(lang) {
      //   alert(lang)
      if (lang === "中文") {
        this.$i18n.locale = "zh";
      }
      if (lang === "English") {
        this.$i18n.locale = "en";
      }
      // changeLang
    },
    onLogo: function() {
      this.$router.push({
        name: "albums"
      });
    },
    onNewAlbum: function() {
      this.$store.commit("setCurrentAlbum", { current_album: null });
      this.$store.commit("setRouteBackTo", {route_back_to: 'albums'});
      this.$router.replace({
        name: "create_album"
      });
    },
    onUploadSheet: function() {
    //   this.$router.push({ name: "home"});
      this.$store.commit("setCurrentSheet", {sheet: null});
      this.$store.commit("setRouteBackTo", {route_back_to: 'albums'});
      this.$router.replace({ name: "upload_sheet_home", params: { is_create_sheet: true }});
    },
    onHandbook: function() {
        if (this.$i18n.locale == "zh") {
            this.$router.replace({
                name: "handbook"
            });
        } else {
            window.open(
              "https://violy.app/blog/2020/02/Create-Sheet-Music-on-Violy/#CREATOR-STUDIO-all-in-Creative", "_blank");
        }
    },
    logout: function() {
      //   this.commonUtils.
      const url = this.commonUtils.getRequestUrl("/logout");
      this.$ajax.get(url).then(
        function(response) {
          const data = response.data;
          if (!data.success) {
            this.$message({
              message: this.$t("login.msg.logout_fail"),
              type: "success"
            });
          } else {
            this.$message({
              message: this.$t("login.msg.logout_success"),
              type: "success"
            });
            this.$router.push({ name: "login" });
          }
        }.bind(this)
      );
    }
  }
};
</script>

<style scoped>
@import "./assets/css/font.css";

.title {
  font-size: 10em;
  height: 35px;
  padding-left: 1em;
}

.normal-text {
  font-size: 12px !important;
}

body {
  /* font-family: SHRegular; */
  font-weight: normal;
}
.logo {
    cursor: pointer;
}
</style>
